import { MOBILE_DEVICE_TYPE } from '../../constants/app-constants';

export const getMobileDeviceType = () => {
    var userAgent = window && (window?.navigator?.userAgent || window?.navigator?.vendor || window?.opera);

    if (/android/i.test(userAgent)) {
        return MOBILE_DEVICE_TYPE.ANDROID;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return MOBILE_DEVICE_TYPE.IOS;
    }

    return '';
};